const spacingProperties = {
  m: 'margin', mt: 'marginTop', mr: 'marginRight', mb: 'marginBottom', ml: 'marginLeft',
  mx: ['marginLeft', 'marginRight'], my: ['marginTop', 'marginBottom'],
  p: 'padding', pt: 'paddingTop', pr: 'paddingRight', pb: 'paddingBottom', pl: 'paddingLeft',
  px: ['paddingLeft', 'paddingRight'], py: ['paddingTop', 'paddingBottom'],
};

const colorTokens = {
  'text.primary': 'var(--erp-text-primary)',
  'text.secondary': 'var(--erp-text-secondary)',
  error: 'var(--erp-danger)',
};

export const responsiveValue = (value) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return value;
  return value.xs ?? value.sm ?? value.md ?? value.lg ?? value.xl;
};

const unit = (value, factor = 1) => typeof value === 'number' && value !== 0 ? `${value * factor}px` : value;

export function sxToStyle(sx = {}) {
  const style = {};
  for (const [key, rawValue] of Object.entries(sx || {})) {
    if (key.startsWith('&') || key.startsWith('@')) continue;
    const value = responsiveValue(rawValue);
    if (spacingProperties[key]) {
      const properties = Array.isArray(spacingProperties[key]) ? spacingProperties[key] : [spacingProperties[key]];
      properties.forEach((property) => { style[property] = unit(value, 8); });
    } else if (key === 'borderRadius') {
      style.borderRadius = unit(value, 4);
    } else if (key === 'color' || key === 'backgroundColor') {
      style[key] = colorTokens[value] || value;
    } else if (key === 'width' && typeof value === 'number' && value > 0 && value <= 1) {
      style.width = `${value * 100}%`;
    } else {
      style[key] = unit(value);
    }
  }
  return style;
}

export const mergeSx = (sx, style) => ({ ...sxToStyle(sx), ...style });
